// src/views/kiddo-games/pick/PictureOfWord.tsx
// Kopia src/components/Pick/PictureOfWord.tsx — tylko dla Wybierz Easy
// Różnica: głośnik w rogu obrazka, wyglądem jak w Znajdź Easy
/* eslint-disable max-len */
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import classes from './PictureOfWord.module.less';
import { ReactComponent as Sound } from '../../../assets/icons/games/find/volume-high.svg';

type CardProps = {
  id: any,
  image?: string,
  alt?: string,
  onSpeakerClick: () => void,
};

export const PictureOfWord: FC<CardProps> = ({
  id, image, alt, onSpeakerClick,
}) => {
  const { t } = useTranslation();

  return (
    <div className={classes.pictureCell}>
      <div className={classes.pickWord} id={id}>
        {image && (
          <img
            src={image}
            alt={alt || t('games:labels.wordImage')}
            className={classes.pickWordImg}
          />
        )}
      </div>
      <button
        type="button"
        className={classes.pictureSpeaker}
        onClick={onSpeakerClick}
        aria-label={t('games:labels.readEnglish')}
      >
        <Sound />
      </button>
    </div>
  );
};

export default PictureOfWord;
